import * as React from 'react'
import * as cn from 'classnames'
import { DVString, EntitlementCueObject } from '@utils'
import * as styles from './Offers.module.scss'
import { Text as DVStringProcessor } from '@amzn/dvui/dist/Text';

interface offersProps {
    offers?: DVString[]
    entitlementCue?: EntitlementCueObject
}

export const Offers = (props: offersProps) => (
    <div className={styles.offers}>
        {props.offers && props.offers.map((offer, index) =>
            (<DVStringProcessor
                key={index}
                string={offer}
                className={cn(styles.offer, {[styles.cueOrange]: props.entitlementCue && props.entitlementCue.colourScheme === 'ORANGE'})}
            />))}
    </div>
)